import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ColectieForWho() {
  const forWho = ['Simți că muncești mult, dar nu ești împlinit/ă. Ai o viață "ok" pe hârtie, dar în interior simți un gol pe care nu îl poți explica.', 'Ai o relație complicată cu banii. Te blochezi mereu în același punct și nu înțelegi de ce abundența vine greu spre tine.', 'Ai citit cărți, ai meditat, ai fost la cursuri, dar n-ai aplicat cu adevărat. Ai multă informație, dar fără un ghid totul rămâne teorie.', 'Te simți blocat/ă emoțional și nu știi exact de ce. Știi doar că ceva te ține pe loc și vrei să te eliberezi.', 'Ești la un moment în viață în care simți că trebuie să faci o schimbare profundă. Ești pregătit/ă să lucrezi cu adevărat la tine.'];
  const notForWho = ['Cauți soluții rapide și "hack-uri". Vrei o pastilă magică după un singur webinar. Academia este un proces în etape care cere implicare și timp.', 'Ești sceptic și respingi ideea de subconștient, meditație sau lucru energetic. Dacă vrei doar "dovezi științifice" fără deschidere, nu vei rezona.', 'Colecționezi cursuri ca pe trofee, fără să practici exercițiile și meditațiile. Academia cere angajament real, nu doar consum de informație.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-424">
      <div className="max-w-6xl mx-auto px-6" data-id="element-425">
        <SectionHeading title="Pentru cine este Academia de Abundență" data-id="element-426" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-427">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-428">
            <div className="flex items-center gap-4 mb-8" data-id="element-429">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-430">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-431" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-432">
                Este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-433">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-434">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-435" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-436">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-437">
            <div className="flex items-center gap-4 mb-8" data-id="element-438">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-439">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-440" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-441">
                NU este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-442">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-443">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-444" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-445">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-446">
          <CTAButton data-id="element-447" />
        </motion.div>
      </div>
    </section>;
}